import { render, staticRenderFns } from "./EmptyOffers.vue?vue&type=template&id=780a3dee&scoped=true&"
import script from "./EmptyOffers.vue?vue&type=script&lang=js&"
export * from "./EmptyOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a3dee",
  null
  
)

export default component.exports